import { ProxyHandlerNameSchema as e } from "./contracts.js";
import { z as t } from "zod";
//#region src/proxy-message/transport.ts
var n = "verity-proxy-external-message", r = "verity-proxy-background-message", i = t.object({ id: t.string() }), a = i.extend({
	type: t.literal(n),
	handler: e,
	params: t.any()
}), o = i.extend({ type: t.literal(r) }), s = t.discriminatedUnion("success", [o.extend({
	success: t.literal(!0),
	result: t.any()
}), o.extend({
	success: t.literal(!1),
	error: t.unknown().optional()
})]);
//#endregion
export { r as PROXY_BACKGROUND_MESSAGE_TYPE, n as PROXY_EXTERNAL_MESSAGE_TYPE, s as ProxyBackgroundMessageSchema, a as ProxyExternalMessageSchema };
